import React from 'react';
import { MessageWithoutEmitter } from './styles';
import MessageChooseContract from '../../../components/MessageChooseContract';

export const ChooseContract = ({
  hasContract,
  isLoading
}: {
  hasContract: boolean;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return <MessageChooseContract />;
  }

  if (!hasContract) {
    return null;
  }
  return (
    <MessageChooseContract>
      <MessageWithoutEmitter>
        Selecione o emissor e o período
        <br />
        para continuar.
      </MessageWithoutEmitter>
    </MessageChooseContract>
  );
};
